module.exports = __webpack_public_path__ + "static/Who's Good-ad7976913868837baee289ca0e110720.jpg";